import * as React from "react";
import type { SVGProps } from "react";
const SvgRectangleHollow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={12}
    fill="none"
    viewBox="0 0 12 12" {...props}
  >
    <rect width={11} height={11} x={0.5} y={0.5} stroke="#000" rx={1.5} />
  </svg>
);
export default SvgRectangleHollow;
